// @flow

import React from "react";
import classNames from "classnames";

import options from "../utils/options";
import { Button } from "../../button";
import Icons from "../../icons";
import type { SchemaTableWidgetProps } from "../types";

import styles from "./icon-button.scss";

export class IconButtonWidget extends React.Component<SchemaTableWidgetProps<Function>> {
  handleClick = () => {
    const onClick = (this.props.options || {}).onClick
      ? (this.props.options || {}).onClick
      : (id: number | string | Object) => {};

    if (typeof onClick === "function") {
      onClick(this.props.row);
    }
  };

  render() {
    const disabled = options.resolveBoolean((this.props.options || {}).disabled, this.props.row);

    const icon = (this.props.options || {}).icon;
    const Icon = icon ? Icons[icon] : Icons.PlusIcon;

    return (
      <div
        className={classNames("icon-button__container", {
          "icon-button__container--disabled": disabled,
        })}
      >
        <Button
          className="link icon-button__button"
          disabled={!this.props.active}
          onClick={this.handleClick}
        >
          <Icon color={disabled ? "disabled" : (this.props.options || {}).iconColor} />
        </Button>
      </div>
    );
  }
}

export default IconButtonWidget;
